module.exports = __webpack_public_path__ + "img/icon_map_3_5.dbe16faa.png";